export class AdminPin {

    public static async unlock(): Promise<boolean> {
        return false
    }

}